import { get, post, del } from '../api.js';
import { navigate } from '../router.js';
import { setTopbar, lucideIcons, esc } from '../app.js';
import { toast, confirmDialog } from '../dialog.js';

export async function renderGrantsList(container) {
  setTopbar('Grants', '<a href="#/grants/new" class="btn btn-primary btn-sm"><i data-lucide="plus" style="width:16px;height:16px"></i> New Grant</a>');

  container.innerHTML = '<p class="loading">Loading...</p>';

  try {
    const grants = await get('/grants');
    const me = await get('/auth/me');
    const myId = me.user_id;

    const sent = grants.filter(g => g.grantor_id === myId);
    const received = grants.filter(g => g.grantor_id !== myId);

    renderTab(container, 'sent', sent, received);
  } catch (err) {
    container.innerHTML = `<div class="msg msg-error">${esc(err.message)}</div>`;
  }
}

function renderTab(container, activeTab, sent, received) {
  const data = activeTab === 'sent' ? sent : received;

  let html = `
    <div class="tabs">
      <div class="tab ${activeTab === 'sent' ? 'active' : ''}" data-tab="sent">Sent</div>
      <div class="tab ${activeTab === 'received' ? 'active' : ''}" data-tab="received">Received</div>
    </div>`;

  if (!data.length) {
    html += `<div class="empty">No grants ${activeTab}</div>`;
  } else {
    html += `<div class="table-wrap"><table>
      <thead><tr>
        <th>${activeTab === 'sent' ? 'Recipient' : 'From'}</th>
        <th>Status</th>
        <th>Views</th>
        <th>Created</th>
        <th></th>
      </tr></thead>
      <tbody>
        ${data.map(g => {
          const policy = typeof g.policy === 'string' ? JSON.parse(g.policy) : g.policy;
          const maxViews = policy?.max_views ? `/${policy.max_views}` : '/∞';
          const person = activeTab === 'sent' ? esc(g.grantee_email) : esc(g.grantor_email || 'Unknown');
          const resendBtn = activeTab === 'sent' && g.status === 'pending' && g.ephemeral_pubkey && g.ephemeral_pubkey.length > 0
            ? `<button class="btn btn-secondary btn-sm resend-btn" data-id="${g.id}">Resend</button> `
            : '';
          const actionBtn = activeTab === 'sent' && g.status !== 'revoked' && g.status !== 'expired'
            ? `${resendBtn}<button class="btn btn-danger btn-sm revoke-btn" data-id="${g.id}">Revoke</button>`
            : activeTab === 'received' && g.status !== 'revoked' && g.status !== 'expired'
            ? `<button class="btn btn-secondary btn-sm access-btn" data-id="${g.id}">Access</button>`
            : '';
          return `<tr>
            <td>${person}</td>
            <td><span class="badge badge-${g.status}">${g.status}</span> <i data-lucide="stamp" style="width:10px;height:10px;color:var(--accent)" title="Provenance notarized"></i></td>
            <td class="mono">${g.view_count}${maxViews}</td>
            <td style="color:var(--text-secondary)">${new Date(g.created_at).toLocaleDateString()}</td>
            <td>${actionBtn}</td>
          </tr>`;
        }).join('')}
      </tbody>
    </table></div>`;
  }

  container.innerHTML = html;
  lucideIcons();

  // Tab switching
  container.querySelectorAll('.tab').forEach(tab => {
    tab.onclick = () => renderTab(container, tab.dataset.tab, sent, received);
  });

  // Revoke buttons
  container.querySelectorAll('.revoke-btn').forEach(btn => {
    btn.onclick = async () => {
      if (!await confirmDialog('Revoke this grant?', { danger: true })) return;
      try {
        await del(`/grants/${btn.dataset.id}`);
        renderGrantsList(container);
      } catch (err) { toast(err.message); }
    };
  });

  // Resend buttons
  container.querySelectorAll('.resend-btn').forEach(btn => {
    btn.onclick = async () => {
      btn.disabled = true;
      btn.textContent = 'Sending...';
      try {
        await post(`/grants/${btn.dataset.id}/resend`);
        btn.textContent = 'Sent!';
      } catch (err) {
        btn.disabled = false;
        btn.textContent = 'Resend';
        toast(err.message);
      }
    };
  });

  // Access buttons
  container.querySelectorAll('.access-btn').forEach(btn => {
    btn.onclick = () => navigate(`#/grants/${btn.dataset.id}/access`);
  });
}
